import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const submitJob = params => {
  let payload = {
    instructions: params.instructions,
    xlsx: params.xlsx,
    csv: params.csv,
    json: params.json,
    api: params.api,
    other: params.other,
    other_format: params.other_format,
    estimated_volume: params.estimatedVolume
  };
  let token = localStorage.getItem("token");
  return axios.post(`${API_URL}/create-job/`, payload, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
};

export default submitJob;
